import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './styles.css';

export interface IButtonLinkProps {
  children: React.ReactNode;
  onClick?(e: React.MouseEvent<HTMLElement>): void;
  block?: boolean;
  fullWidth?: boolean;
  theme?: 'white';
  testId?: string;
}

export function ButtonLink({ children, block, theme, onClick, testId, fullWidth }: IButtonLinkProps) {
  return (
    <button
      data-testid={testId}
      type="button"
      className={clsx(
        styles['link'],
        block && styles['link--block'],
        theme && styles[`link--${theme}`],
        fullWidth && styles[`link--fullwidth`],
      )}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
